class Auth {
  private TokenKey = `AuthToken`;
  private RefreshTokenKey = `RefreshToken`;

  logout() {
    window.sessionStorage.clear();
    window.localStorage.clear();
  }

  getAuthToken(): string {
    const authToken = window.localStorage.getItem(this.TokenKey);
    return authToken === null ? "" : authToken;
  }

  isLoggedIn(): boolean {
    const authToken = this.getAuthToken();
    return authToken.length > 0;
  }

  getRefreshToken(): string {
    const refreshToken = window.localStorage.getItem(this.RefreshTokenKey);
    return refreshToken === null ? "" : refreshToken;
  }

  handleTokenResponse(data: any): void {
    localStorage.setItem(this.TokenKey, data["access_token"]);
    localStorage.setItem(this.RefreshTokenKey, data["refresh_token"]);
  }
}

export default new Auth();
